<template>
  <zm-dialog class="zwb-plan-details" :class="$context.is.modal ? 'opc-modal-dialog' : ''" :visible.sync="visible" :show-close="!$context.is.modal" :before-close="handleBeforeClose">
    <NavBack v-if="$context.is.modal" :backHandler="handleCancel" class="mb24" slot="title" />
    <!--header-->
    <BasePlanDetails>
      <span slot="title">{{ title }}</span>
      <template #price>
        <price-list class="zwb-plan-details__price-list" :showDecimalPoint="$context.is.desktop" :plan-category="planCategory" :unit-type="planUnitMap.license"/>
      </template>
      <ul slot="desc">
        <li v-for="item in descList" :key="item">{{ item }}</li>
      </ul>
      <zm-button slot="action" type="link" class="plan-details__confirm-btn text-capitalize" @click="handleSure">
        {{ $t('billing.pbx.plan_details.view_more') }}
      </zm-button>
    </BasePlanDetails>
  </zm-dialog>
</template>
<script type="text/jsx">
import BasePlanDetails from '@/plans/EVENT_SAAS/component/dialog/plan-details/base.vue';
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import { planTypes, trackingPlanTypes } from '@/common/constants';
import { get } from 'lodash';
import PriceList from "@/components/price-list.vue";
import { planUnitMap } from '@/common/product-unit';
import NavBack from '@/components/nav-back.vue';

export default {
  name: 'PlanDetails',
  mixins: [ConfirmComponent],
  components: {
    PriceList,
    BasePlanDetails,
    NavBack,
  },
  props: {
    planList: Array,
    planType: String,
    title: String,
    planCategory: String,
  },
  data() {
    return {
      visible: false,
      planUnitMap
    };
  },
  methods: {
    handleSure() {
      this.$tracking.buyInteraction('product details',
        `${this.trackingPlanKey} plan details -  view more`);
    },
    handleBeforeClose() {
      this.$tracking.buyInteraction('product details',
        `${this.trackingPlanKey} plan details - exit`);
      this.handleCancel();
    },
  },
  computed: {
    trackingPlanKey() {
      return get(trackingPlanTypes, get(planTypes, this.planType));
    },
    descList() {
      return {
        [planTypes.ZOOM_WHITEBOARD]: [
          this.$t('unlmitedConcurrentlyEditableWhiteboards'),
          this.$t('standardFeaturesAndAdvancedDocumentControl'),
          this.$t('canBeAddedToZoomOneBasicOrProPlans'),
        ],
        [planTypes.ZOOM_WHITEBOARD_PLUS]: [
          this.$t('billing.zoom_whiteboard.unlimited_concurrently_editable_whiteboards'),
          this.$t('advancedWhiteboardFeatures')
        ],
      }[this.planType]
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(v) {
        v && this.$tracking.buyInteraction('product details', `${this.trackingPlanKey} plan details - impression`);
      }
    }
  },
}
</script>
<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/scss-utils.scss';

.zwb-plan-details {
  &.opc-modal-dialog {
    .zm-dialog {
      width: 100% !important;
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      height: 100%;
      max-width: 100%;
      border-radius: 0;
      overflow: auto;
      scrollbar-width: none;
      @include media(tablet) {
        padding: 32px 60px !important;
      }
      .zm-dialog__body {
        scrollbar-width: none;
        &::-webkit-scrollbar {
          display: none;
        }
        .mb24 {
          margin-bottom: 24px;
        }
      }
      .zm-dialog__header {
        padding: 0;
        margin-bottom: 8px;
        .zm-dialog__headerbtn {
          position: absolute;
          top: 16px;
          right: 16px;
        }
      }
    }

  }
  .zm-dialog {
    padding: 72px 60px;
    min-width: 555px;
    width: fit-content;
  }

  .plan-details__price {
    display: flex;
  }

  &__price-list {
    @include media(mobile, tablet) {
      margin-top: 16px;
    }
  }

  .plan-details__desc {
    padding-left: 20px;
    ul {
      list-style: disc;
      li {
        list-style: disc;
        color: #00053D;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        @include darkTextColor;
      }
    }
  }
}
</style>
